export default `
mutation RestoreServiceProviderUser($userId: AWSEmail!, $serviceProviderId: ID!){
  restoreServiceProviderUser(userId: $userId, serviceProviderId: $serviceProviderId) {
    coordinates {
      lat
      lng
    }
    officerLevel
    userId
    updatedAt
    displayName
    serviceProviderId
    status
    role
    respondingTo {
      instanceId
      propertyId
    }
    isDeleted
    inRange
  }
}
`;